<script type="ts">
  export let className = '';
  export const resetScroll = () => {
    scrollContainer.scrollTop = 0;
  };

  let scrollContainer: HTMLDivElement;
</script>

<div class="scr {className}" bind:this={scrollContainer}>
  <slot />
</div>

<style lang="scss">
  .scr {
    height: 100%;
    width: 100%;
    flex: 1;
    padding: 4px;
    padding-bottom: 150px;
    overflow: auto;
  }
</style>
